export default __webpack_public_path__ + "static/media/landing.7c83430c.svg";